import { LinkTypes } from 'helpers/enumerations';
import { GeneralContentTab } from '../GeneralContentTab';

function SmeTab() {
    return (
        <GeneralContentTab
            contentName={'Sme'}
            linkTypeId={LinkTypes.SubjectMatterExpert.id}
            contentTypes={LinkTypes.SubjectMatterExpert.contentTypes}
        />
    );
}

export { SmeTab };
